import * as React from 'react'
import styled from 'styled-components'
import { Link } from '../../../../common/src/components/Link'
import { H1, Spacer, H3, BodyText } from '../../../../common/src/components/core'
import { Colors } from '../../../../common/src/constants'
import { formatInt } from '../../../../common/src/format'
import { FetchAdminQuery, FirmType } from '../../../../common/src/types.gen'
import { getFirmPath } from '../route'

export function FirmsDetail({ firms }: { firms?: FetchAdminQuery['allFirms'] }) {
  const nonDisabled = firms?.filter(f => f.firmType !== FirmType.DISABLED && f.firmType !== FirmType.ADMIN)
  const sorted = nonDisabled?.sort((a, b) => b.numUnits - a.numUnits)

  // firms older than this many days are 'old'
  const oldNewDaysSplit = 60
  const sixtyDaysAgo = new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 60)
  const newFirms = sorted?.filter(firm => new Date(firm.timeCreated).getTime() >= sixtyDaysAgo.getTime())
  const oldFirms = sorted?.filter(firm => new Date(firm.timeCreated).getTime() < sixtyDaysAgo.getTime())

  return (
    <div style={{ width: '800px' }}>
      <H1>Firms</H1>
      <Spacer height={32} />

      <H3>
        {'<'} {oldNewDaysSplit} Days Old
      </H3>
      <Spacer height={8} />

      <FirmsContainer>
        {newFirms?.map(firm => (
          <SingleFirm key={firm.id} firm={firm} />
        ))}
      </FirmsContainer>

      <Spacer height={32} />

      <H3>Older</H3>
      <Spacer height={8} />

      <FirmsContainer>
        {oldFirms?.map(firm => (
          <SingleFirm key={firm.id} firm={firm} />
        ))}
      </FirmsContainer>
      <Spacer height={64} />
    </div>
  )
}

function SingleFirm({ firm }: { firm: FetchAdminQuery['allFirms'][0] }) {
  return (
    <Firm to={getFirmPath(firm.id)}>
      <FirmName color={'silver'}>{firm.firmName}</FirmName> <UnitCount>{formatInt(firm.numUnits)} units</UnitCount>
    </Firm>
  )
}

const FirmsContainer = styled(BodyText)`
  column-count: 3;
`

const FirmName = styled.span`
  color: ${Colors.silver};
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: middle;
  transition: 150ms;
`

const UnitCount = styled.span`
  font-size: 10px;
  display: inline-block;
  vertical-align: middle;
  transition: 150ms;
`

const Firm = styled(Link)`
  padding: 2px;
  margin-right: 10px;
  overflow: hidden;
  white-space: nowrap;
  word-break: keep-all;
  display: block;
  color: ${Colors.midway};

  &:hover {
    color: ${Colors.midway};

    ${FirmName} {
      color: ${Colors.white};
    }

    ${UnitCount} {
      color: ${Colors.silver};
    }
  }
`
